var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDocumentsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 294,
    viewBox: "0 0 485 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.961262 0.275637 0.275637 0.961262 420.246 147.394)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.961262 0.275637 0.275637 0.961262 183.617 104.975)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 35,
    rx: 17.5,
    transform: "matrix(-0.961262 0.275637 0.275637 0.961262 589.258 -11.1489)",
    fill: "#435E64"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180.32,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.961262 0.275637 0.275637 0.961262 392.43 45.0464)",
    fill: "#5D7C84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1845,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.961262 0.275637 0.275637 0.961262 392.43 45.0464)",
    fill: "#86AAB4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 180.32,
    height: 35.1845,
    rx: 17.5922,
    transform: "matrix(-0.961262 0.275637 0.275637 0.961262 623.508 89.0547)",
    fill: "#5D7C84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocumentsRight);
export default __webpack_public_path__ + "static/media/no-documents-right.2d963517b8b60a09995afc322dfa8f05.svg";
export { ForwardRef as ReactComponent };